<template>
  <div class="border rounded flex justify-start space-y-2 space-x-2 p-2 flex-wrap">
    <!-- Display existing tags -->
    <div v-for="(tag, index) in modelValue" :key="index" @mouseover="hoveredIndex = index" @mouseleave="hoveredIndex = null"  class="bg-accent px-3 py-1 text-body  rounded text-accent-foreground">
      {{ tag }}
      <span v-if="hoveredIndex === index" class="delete-icon" @click="removeTag(index)" > × </span>
    </div>

    <!-- Input for adding new tags -->
    <input v-model="newTag" @keydown.enter="addTag" @keydown.backspace="handleBackspace" placeholder="Add a tag..." class="tag-input bg-transparent text-sm" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

interface Props {
  modelValue: string[];
}

const props = defineProps<Props>();
const emit = defineEmits<{
  (e: 'update:modelValue', value: string[]): void;
  (e: 'tag-added', tag: string): void;
  (e: 'tag-removed', index: number): void;
}>();

const newTag = ref('');
const hoveredIndex = ref<number | null>(null);

const addTag = () => {
  const trimmedTag = newTag.value.trim();
  if (trimmedTag && !props.modelValue.includes(trimmedTag)) {
    const newTags = [...props.modelValue, trimmedTag];
    emit('update:modelValue', newTags);
    emit('tag-added', trimmedTag);
    newTag.value = '';
  }
};

const removeTag = (index: number) => {
  const updatedTags = [...props.modelValue];
  const [removedTag] = updatedTags.splice(index, 1);
  emit('update:modelValue', updatedTags);
  emit('tag-removed', index);
};

const handleBackspace = () => {
  if (newTag.value === '' && props.modelValue.length > 0) {
    removeTag(props.modelValue.length - 1);
  }
};
</script>

<style scoped>
/* Your existing styles remain the same */
.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  min-height: 40px;
}

.tag {
  position: relative;
  background: #e0e0e0;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
}

.delete-icon {
  margin-left: 4px;
  cursor: pointer;
  color: #ff4444;
  font-weight: bold;
}

.tag-input {
  flex: 0 1 auto;
  border: none;
  outline: none;
  padding: 4px 6px;
  min-width: 80px;
  max-width: 120px;
  font-size: 0.875rem;
}
</style>
